export abstract class DestinationTaskConfigBase {
	successMappingID = '';
	failureMappingID = '';

	constructor(init?: Partial<DestinationTaskConfigBase>) {
		if (init) {
			Object.assign(this, init);
		}
	}

	GetDestinationTasks(): string[] {
		const taskDestinations: string[] = [];
		if (!this.successMappingID) {
			throw new Error('The success mapping does not have a ID assigned to it');
		}
		taskDestinations.push(this.successMappingID);
		if (this.failureMappingID) {
			taskDestinations.push(this.failureMappingID);
		}
		return taskDestinations;
	}
}
